import { Checkbox, FormControlLabel, FormGroup } from "@mui/material";
import Box from "@mui/material/Box";
import React from "react";
import { produce } from "immer";

const CreateProductGroupCategoryTab = ({ 
                                           activeCategory,
                                           categories,
                                           setActiveForm }) =>
{
    const handleCategoryItemSelection = (event, checked, categoryId, itemId) => {
        setActiveForm(prevState => produce(prevState, draft => {
            const category = draft.categories.find(x => x.id === categoryId);
            if (!category) return;

            const items = category.productItems;
            const item = items.find(x => x.id === itemId);

            if (checked) {
                if (!item) {
                    const itemInCategory = categories.find(x => x.id === categoryId)?.productItems?.find(item => item.id === itemId);
                    if (itemInCategory) {
                        items?.push(itemInCategory);
                    }
                }
            } else {
                category.productItems = items?.filter(item => item.id !== itemId);
            }
        }));
    };
    
    return (
        <>
            <Box>
                {categories.find((x) => x.id === activeCategory.id)?.productItems && (
                    <>
                        <FormGroup>
                            {categories.find((x) => x.id === activeCategory.id)?.productItems?.map((item, index) => (
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            checked={!!activeCategory.productItems.find(i => i.id === item.id)}
                                            onChange={(event, checked) => handleCategoryItemSelection(event, checked, activeCategory.id, item.id)}
                                        />
                                    }
                                    label={item.name}
                                    key={index}
                                />
                            ))}
                        </FormGroup>
                    </>
                )}
            </Box>
        </>
    );
}

export default CreateProductGroupCategoryTab;